export const getSessionStatus = (error) => {
  const status = error?.response?.status || error?.statusCode || error?.status
  return Number(status)
}

export const isSessionExpired = (error) => {
  const status = getSessionStatus(error)
  return (
    status === 401 ||
    status === 403 ||
    error?.sessionExpired === true ||
    error?.data?.sessionExpired === true
  )
}

export const getReturnToPath = (rawPath, baseURL) => {
  const path = rawPath || '/'
  const base = (baseURL || '/').replace(/\/+$/, '')

  if (!base || base === '/') return path
  return path.startsWith(base) ? path.slice(base.length) || '/' : path
}

export const getAuthCookiePath = (baseURL) => {
  const base = (baseURL || '/').replace(/\/+$/, '')
  return base ? `${base}/` : '/'
}

export const getAuthCookiePaths = (baseURL) => {
  const path = getAuthCookiePath(baseURL)
  return path === '/' ? ['/'] : [path, '/']
}

export const createSessionExpiredError = (error) => {
  const sessionError = new Error('Session expired')
  sessionError.response = error?.response || { status: 403 }
  sessionError.statusCode = 403
  sessionError.data = error?.data || error
  sessionError.sessionExpired = true
  return sessionError
}
